import { IconTileView } from '../../common/atoms/IconTile';
import { CardActionsGroupView } from '../atoms/CardActionsGroup';
import { CardBadgeView } from '../atoms/CardBadge';
import { CardHeaderView } from '../atoms/CardHeader';
import { CardShellView } from '../atoms/CardShell';
import type { CardViewProps } from './Card.types';

export function CardView({ icon, title, subtitle, badge, actions, loading = false, onClick, children }: CardViewProps) {
  return (
    <CardShellView loading={loading} onClick={onClick} skeletonAvatar={!!icon} style={{ display: 'flex', flexDirection: 'column' }}>
      <CardHeaderView
        icon={icon && <IconTileView icon={icon.icon} color={icon.color} />}
        title={title}
        description={subtitle}
        badge={badge && <CardBadgeView label={badge.label} tone={badge.tone} color={badge.color} />}
        actions={actions && <CardActionsGroupView actions={actions} />}
      />
      {children}
    </CardShellView>
  );
}
